import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavBar from '../NavBar/NavBar';
import { Snackbar, Alert, Button } from '@mui/material';
import { getFirestore, getDocs, getDocsFromServer, collection, query as queryFs, limit as limitFs } from "firebase/firestore";
import { getDatabase, ref, get, query as queryDb, limitToFirst } from "firebase/database";
import { firestore as firestoreLite } from '../../firebase';
import { getDocs as getDocsLite, collection as collectionLite, query as queryLite, limit as limitLite } from 'firebase/firestore/lite';

function DiagnosticPanel() {
    const [open, setOpen] = useState(false);
    const [log, setLog] = useState({
        projectId: 'personal-gestion',
        user: 'Ninguno',
        firestoreStatus: 'Cargando...',
        firestoreCount: 0,
        firestoreServerCount: 'Cargando...',
        firestoreError: 'Ninguno',
        firestoreLiteStatus: 'Cargando...',
        firestoreLiteCount: 0,
        firestoreLiteError: 'Ninguno',
        rtdbStatus: 'Cargando...',
        rtdbError: 'Ninguno',
    });

    const runDiagnostics = async () => {
        const currentUser = localStorage.getItem("currentUser");
        const userObj = currentUser ? JSON.parse(currentUser) : null;
        
        const state = {
            projectId: 'personal-gestion',
            user: userObj ? `${userObj.userName} (${userObj.rol})` : 'No autenticado en localStorage',
            firestoreStatus: 'Cargando...',
            firestoreCount: 0,
            firestoreServerCount: 0,
            firestoreError: 'Ninguno',
            firestoreLiteStatus: 'Cargando...',
            firestoreLiteCount: 0,
            firestoreLiteError: 'Ninguno',
            rtdbStatus: 'Cargando...',
            rtdbError: 'Ninguno',
        };

        // Test Firestore (Full SDK)
        try {
            const db = getFirestore();
            const snap = await getDocs(queryFs(collection(db, 'cuadrillas'), limitFs(5)));
            state.firestoreStatus = 'Conectado exitosamente';
            state.firestoreCount = snap.size;

            try {
                const snapServer = await getDocsFromServer(queryFs(collection(db, 'cuadrillas'), limitFs(5)));
                state.firestoreServerCount = snapServer.size;
            } catch (serverErr) {
                state.firestoreServerCount = 'Error: ' + (serverErr.message || serverErr.toString());
            }
        } catch (err) {
            state.firestoreStatus = 'Fallo de conexión';
            state.firestoreError = err.message || err.toString();
        }

        // Test Firestore Lite SDK
        try {
            const snapLite = await getDocsLite(queryLite(collectionLite(firestoreLite, 'cuadrillas'), limitLite(5)));
            state.firestoreLiteStatus = 'Conectado (Lite)';
            state.firestoreLiteCount = snapLite.size;
        } catch (liteErr) {
            state.firestoreLiteStatus = 'Fallo (Lite)';
            state.firestoreLiteError = liteErr.message || liteErr.toString();
        }

        // Test RTDB
        try {
            const db = getDatabase();
            const snapshot = await get(queryDb(ref(db, 'users'), limitToFirst(1)));
            state.rtdbStatus = 'Conectado exitosamente';
        } catch (err) {
            state.rtdbStatus = 'Fallo de conexión';
            state.rtdbError = err.message || err.toString();
        }

        setLog(state);
    };

    useEffect(() => {
        runDiagnostics();
    }, []);

    return (
        <div style={{
            position: 'fixed',
            bottom: '10px',
            left: '10px',
            zIndex: 99999,
            fontFamily: 'monospace',
            fontSize: '11px',
            background: '#222',
            color: '#0f0',
            padding: '5px',
            border: '1px solid #0f0',
            borderRadius: '4px',
            opacity: 0.95,
            boxShadow: '0 0 10px rgba(0,0,0,0.5)'
        }}>
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <button 
                    onClick={() => setOpen(!open)}
                    style={{
                        background: '#0f0',
                        color: '#222',
                        border: 'none',
                        borderRadius: '2px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '10px',
                        padding: '2px 5px'
                    }}
                >
                    {open ? 'Cerrar Panel' : 'Diagnóstico de BD'}
                </button>
                <button 
                    onClick={runDiagnostics}
                    style={{
                        background: '#555',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '2px',
                        cursor: 'pointer',
                        fontSize: '10px',
                        padding: '2px 5px'
                    }}
                >
                    Reintentar
                </button>
            </div>
            
            {open && (
                <div style={{ marginTop: '10px', width: '280px', maxHeight: '350px', overflowY: 'auto' }}>
                    <div><strong>Proyecto:</strong> {log.projectId}</div>
                    <div><strong>Usuario local:</strong> {log.user}</div>
                    <hr style={{ borderColor: '#0f0', margin: '5px 0' }} />
                    <div><strong>Firestore (Full SDK):</strong> {log.firestoreStatus}</div>
                    <div><strong>Count (Caché):</strong> {log.firestoreCount}</div>
                    <div><strong>Count (Servidor):</strong> {log.firestoreServerCount}</div>
                    {log.firestoreError !== 'Ninguno' && (
                        <div style={{ color: '#ff5555', wordBreak: 'break-all' }}><strong>Error Full SDK:</strong> {log.firestoreError}</div>
                    )}
                    <hr style={{ borderColor: '#0f0', margin: '5px 0' }} />
                    <div><strong>Firestore (Lite SDK):</strong> {log.firestoreLiteStatus}</div>
                    <div><strong>Count (Lite):</strong> {log.firestoreLiteCount}</div>
                    {log.firestoreLiteError !== 'Ninguno' && (
                        <div style={{ color: '#ff5555', wordBreak: 'break-all' }}><strong>Error Lite SDK:</strong> {log.firestoreLiteError}</div>
                    )}
                    <hr style={{ borderColor: '#0f0', margin: '5px 0' }} />
                    <div><strong>RTDB status:</strong> {log.rtdbStatus}</div>
                    {log.rtdbError !== 'Ninguno' && (
                        <div style={{ color: '#ff5555', wordBreak: 'break-all' }}><strong>RTDB Err:</strong> {log.rtdbError}</div>
                    )}
                </div>
            )}
        </div>
    );
}

function Layout() {
    const location = useLocation();
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    
    // Ocultar NavBar solo en la ruta del Hub (/hub)
    const showNavBar = currentUser && location.pathname !== '/hub';

    const [currentVersion, setCurrentVersion] = useState(null);
    const [hasNewVersion, setHasNewVersion] = useState(false);

    useEffect(() => {
        // Obtener versión inicial
        const fetchInitialVersion = async () => {
            try {
                const res = await fetch('/version.json?t=' + Date.now());
                const data = await res.json();
                if (data && data.version) {
                    setCurrentVersion(data.version);
                }
            } catch (e) {
                console.error("Error al obtener la versión inicial:", e);
            }
        };
        fetchInitialVersion();
    }, []);

    useEffect(() => {
        if (!currentVersion) return;

        const checkVersion = async () => {
            try {
                const res = await fetch('/version.json?t=' + Date.now());
                const data = await res.json();
                if (data && data.version && data.version !== currentVersion) {
                    setHasNewVersion(true);
                }
            } catch (e) {
                console.error("Error al verificar nueva versión:", e);
            }
        };

        // Verificar cada 1 minuto
        const interval = setInterval(checkVersion, 60000);
        return () => clearInterval(interval);
    }, [currentVersion]);

    const handleUpdate = () => {
        window.location.reload(true);
    };

    return (
        <>
            {showNavBar && <NavBar />}
            <Outlet />
            <Snackbar
                open={hasNewVersion}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert 
                    severity="info" 
                    variant="filled"
                    action={
                        <Button color="inherit" size="small" onClick={handleUpdate} sx={{ fontWeight: 'bold' }}>
                            Actualizar
                        </Button>
                    }
                >
                    Hay una nueva versión disponible.
                </Alert>
            </Snackbar>
        </>
    );
}

export default Layout;
